export default __webpack_public_path__ + "static/media5-bf5b367a413c74aecf2a08960b363a76.jpg";